import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7OPCVMUnderlyingTSEdit } from "./edit";
import { A7OPCVMUnderlyingTSTable } from "./table";

export default function A7OPCVMUnderlyingTS() {
  useEffect(() => {
    setDocumentTitle(
      "Quantilia | OPCVM Instruments Financiers Séries Temporelles",
    );
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7OPCVMUnderlyingTSEdit />} />
      <Route index element={<A7OPCVMUnderlyingTSTable />} />
    </Routes>
  );
}
